<template>
  <div class="dashboard body">
    <el-container>
      <!-- <Aside @toggle="toggle($event)" /> -->

      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f10']"
          @shortkey="confirmSave = true"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f9']"
          @shortkey="saveShortKey"
        ></button>
        <div style="margin-top: -11px">
          <el-button
            plain
            @click="setSelectedInvoice(index)"
            style="margin-right: 5px"
            v-for="(invoice, index) in purchases"
            :key="index"
            :type="selectedIndex == index ? 'warning' : 'success'"
          >
            {{ index + 1 }}
          </el-button>
          <el-button
            plain
            type="primary"
            style="margin-right: 5px"
            @click="addNewInvoice"
          >
            <i class="fas fa-plus"></i>
          </el-button>
        </div>
        <el-row :gutter="10">
          <el-col :xl="24" :lg="24" :md="24" :sm="24">
            <SearchSuppliers
              ref="searchSuppliersComponent"
              :supplier="purchases[selectedIndex].supplier"
              @selectedSupplier="selectedSupplier"
              :productsLength="purchases[selectedIndex].products.length"
              :searchOnly="false"
              :showLabel="true"
              :useParcode="useParcode"
            />
          </el-col>
        </el-row>

        <div class="row">
          <div class="col-md-6 d-flex gap-3">
            <div class="" v-if="purchases[selectedIndex].products.length > 0">
              <h6
                class="inline-card p-3 mt-2 d-flex justify-content-center flex-column"
              >
                <span>الكميه</span>
                <span class="num">{{
                  purchases[selectedIndex].total_qty
                }}</span>
              </h6>
            </div>

            <div class="" v-if="purchases[selectedIndex].products.length > 0">
              <h6
                class="inline-card p-3 mt-2 d-flex justify-content-center flex-column"
              >
                <span>الفاتوره</span>
                <span>{{
                  numberToFixed(purchases[selectedIndex].total_buy_cost)
                }}</span>
              </h6>
            </div>

            <div v-if="purchases[selectedIndex].total_discount > 0">
              <h6
                class="inline-card p-3 mt-2 d-flex justify-content-center flex-column"
              >
                <span>بعد الخصم</span>
                <span>{{
                  numberToFixed(
                    purchases[selectedIndex].total_buy_cost -
                      purchases[selectedIndex].total_discount
                  )
                }}</span>
              </h6>
            </div>
          </div>

          <div class="col-md-6">
            <div
              style="height: 100%"
              class="d-flex align-items-center gap-1 flex-row-reverse"
            >
              <span>
                <el-popconfirm
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد مسح الفاتورة؟"
                  @confirm="resetInvoiceData"
                >
                  <div slot="reference">
                    <el-button type="danger" class="mr-3"
                      >مسح الفاتورة</el-button
                    >
                  </div>
                </el-popconfirm>
              </span>

              <el-button
                v-if="purchases[selectedIndex].products.length > 0"
                type="primary"
                :loading="isLoading"
                @click="confirmSave = true"
                >حفظ الفاتوره</el-button
              >
            </div>
          </div>
        </div>
        <el-row class="table mt-2 px-3 invoices-table">
          <div
            class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
            style="height: 59vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="50%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="10%" />
                  <col name="el-table_3_column_17" width="5%" />
                  <col name="el-table_3_column_18" width="5%" />
                  <!-- <col name="el-table_3_column_18" width="10%" />
                  <col name="el-table_3_column_19" width="10%" />
                  <col name="el-table_3_column_20" width="6%" /> -->
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <!-- <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الوحدة</div>
                    </th> -->
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">سعر الشراء</div>
                    </th>

                    <!-- <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">أخر سعر</div>
                    </th> -->
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <!-- <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">سعر الجملة</div>
                    </th> -->
                    <!-- <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">جملة الجملة</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th> -->
                    <th
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell"></div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              style="height: auto; max-height: 45vh"
              ref="products_table"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__body"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="50%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="10%" />
                  <col name="el-table_3_column_17" width="5%" />
                  <col name="el-table_3_column_18" width="5%" />
                  <!-- <col name="el-table_3_column_18" width="10%" />
                  <col name="el-table_3_column_19" width="10%" />
                  <col name="el-table_3_column_20" width="6%" /> -->
                </colgroup>
                <!-- id="order" -->
                <tbody class="bodytable">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in purchases[selectedIndex].products"
                    :key="index"
                  >
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_11"
                      data-label="#"
                    >
                      <div class="cell num">{{ index + 1 }}</div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="2"
                      class="el-table_3_column_12"
                      data-label="المنتج"
                    >
                      <div class="cell">{{ item.name }}</div>
                    </td>

                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_14"
                      data-label="الكمية"
                    >
                      <div class="cell">
                        <input
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.qty"
                          placeholder="الكمية"
                          min="0"
                        />
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_15"
                      data-label="سعر الشراء"
                    >
                      <div class="cell">
                        <input
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.buy_cost"
                          placeholder="سعر الشراء"
                          min="0"
                        />
                      </div>
                    </td>
                    <!-- <td rowspan="1" colspan="1" class="el-table_3_column_16">
                      <div class="cell center">
                        {{ numberToFixed(item.lastPurchaseCost) }}
                      </div>
                    </td> -->
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_17"
                      data-label="الإجمالي"
                    >
                      <div class="cell center">
                        {{ numberToFixed(item.buy_cost * item.qty) }}
                      </div>
                    </td>

                    <!-- <td rowspan="1" colspan="1" class="el-table_3_column_15">
                      <div class="cell">
                        <input
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.sale_price"
                          placeholder="سعر الجملة"
                          min="0"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_15">
                      <div class="cell">
                        <input
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.wholesale_price"
                          placeholder="جملة الجملة"
                          min="0"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_18">
                      <div class="cell center">
                        {{ numberToFixed(item.stock) }}
                      </div>
                    </td> -->
                    <td rowspan="1" colspan="2" class="el-table_3_column_19">
                      <div class="cell">
                        <el-popconfirm
                          confirm-button-text="موافق"
                          cancel-button-text="إلغاء"
                          icon="el-icon-info"
                          icon-color="red"
                          :title="'هل تريد حذف ' + ' ' + item.name + ' ؟'"
                          @confirm="deleteItem(item, index)"
                        >
                          <div slot="reference" class="deleteicon">
                            <i class="fas fa-trash-alt"></i>
                          </div>
                        </el-popconfirm>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
            <div
              class="el-table__footer-wrapper"
              v-if="purchases[selectedIndex].supplier"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__footer"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="50%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="10%" />
                  <col name="el-table_3_column_17" width="5%" />
                  <col name="el-table_3_column_18" width="5%" />
                </colgroup>
                <tbody class="has-gutter footer">
                  <tr>
                    <!-- <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell num">{{ ind + 1 }}</div>
                    </td> -->
                    <td
                      colspan="3"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                      data-label="المنتج"
                    >
                      <div class="cell">
                        <!-- value-key="name" -->
                        <div class="searchInput">
                          <SearchProducts
                            :allowCreateNewProduct="true"
                            @addNewProduct="addNewProductWithValue"
                            :activeSide="activeSide"
                            :showStockZero="true"
                            ref="searchProductsComponent"
                            :supplier="supplier"
                            @selectedProduct="selectedProduct"
                            @productQueryChange="productQueryChange"
                            @selectedProductWithBarcode="
                              selectedProductWithBarcode
                            "
                          />
                        </div>
                      </div>
                    </td>

                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                      data-label="الكمية"
                    >
                      <div class="cell qty">
                        <el-input
                          type="text"
                          ref="qty"
                          @focus="$event.target.select()"
                          @keyup.enter.native="setPriceFocus"
                          v-model="qty"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                      data-label="سعر الشراء"
                    >
                      <div class="cell buy_cost">
                        <el-input
                          type="text"
                          ref="buy_cost"
                          v-model="buy_cost"
                          @focus="$event.target.select()"
                          @keyup.enter.native="addNewItem"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <!-- <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell center">
                        {{ selectedProductlastBuyCost }}
                      </div>
                    </td> -->
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                      data-label="الإجمالي"
                    >
                      <div class="cell center" v-if="qty * buy_cost > 0">
                        {{ numberToFixed(qty * buy_cost) }}
                      </div>
                      <div class="cell center" v-else>-</div>
                    </td>
                    <!-- <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell sale_price">
                        <el-input
                          type="text"
                          ref="sale_price"
                          v-model="sale_price"
                          @focus="$event.target.select()"
                          @keyup.enter.native="setWholeSalePriceFocus"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell wholesale_price">
                        <el-input
                          type="text"
                          ref="wholesale_price"
                          v-model="wholesale_price"
                          @focus="$event.target.select()"
                          @keyup.enter.native="addNewItem"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>

                    <td
                      v-if="product"
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">{{ selectedProductStock }}</div>
                    </td> -->
                    <td
                      v-if="product"
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <el-button
                        type="success"
                        @click="addNewItem"
                        title="إضافة المنتج"
                      >
                        <i class="fas fa-plus"></i>
                      </el-button>
                    </td>
                    <td
                      v-if="product == null && accessLinks('add_new_product')"
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_20 is-leaf"
                    >
                      <!-- <div class="cell center">
                        <el-button
                          id="newProductBtn"
                          @click="showAddModel"
                          type="success"
                          size="small"
                          >إضافة منتج جديد</el-button
                        >
                      </div> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-row>
        <!-- <el-row :gutter="10" class="footer">
          <el-col :xl="8" :lg="8" :md="18" :sm="24"
            ><div
              class="bg-White alignment px-3 mt-2"
              v-if="purchases[selectedIndex].products.length > 0"
            >
              <el-row :gutter="5">
                <el-col :span="12">
                  <label for="">خصم بالقيمة</label>

                  <el-input
                    @change="discountChange"
                    @focus="$event.target.select()"
                    v-model="purchases[selectedIndex].total_discount"
                    placeholder="قيمه الخصم"
                    align="middle"
                  >
                     <template slot="append">خصم</template>
                  </el-input>
                </el-col>
                <el-col :span="12">
                  <label for="">خصم بالنسبة %</label>
                  <el-input
                    @change="discountPreChange"
                    @focus="$event.target.select()"
                    v-model="purchases[selectedIndex].percentage_discount"
                    placeholder="الخصم بالنسبة المئوية"
                  >
                    <template slot="append">% خصم</template>
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row> -->
      </el-main>
      <div v-if="confirmSave == true" class="dialog">
        <div class="bodySec">
          <p @click="confirmSave = false">
            <span><i class="far fa-times-circle"></i></span> اغلاق
          </p>
        </div>
        <div class="content">
          <div class="headerSection">
            <p>الرصيد السابق</p>
            <p class="mr-auto">
              {{
                numberToFixed(
                  Number(purchases[selectedIndex].supplier.balance) +
                    Number(purchases[selectedIndex].supplier.account)
                )
              }}
            </p>
          </div>
          <div class="headerSection mt-2">
            <p>اجمالي الفاتوره</p>
            <p class="mr-auto">
              {{
                numberToFixed(
                  Number(purchases[selectedIndex].total_buy_cost) -
                    Number(purchases[selectedIndex].total_discount)
                )
              }}
            </p>
          </div>
          <div class="headerSection mt-2">
            <p>اجمالي المدونية</p>
            <p class="mr-auto">
              {{
                numberToFixed(
                  Number(purchases[selectedIndex].total_buy_cost) -
                    Number(purchases[selectedIndex].total_discount) +
                    Number(purchases[selectedIndex].supplier.balance)
                ) +
                numberToFixed(Number(purchases[selectedIndex].supplier.account))
              }}
            </p>
          </div>
          <div class="mt-2">
            <el-radio-group
              v-model="setPaied"
              style="justify-content: start !important"
            >
              <el-radio-button label="without">حفظ بدون توريد</el-radio-button>
              <el-radio-button @click="alert" label="with"
                >توريد</el-radio-button
              >
            </el-radio-group>
          </div>
          <div v-if="setPaied == 'with'">
            <el-row>
              <el-col> <p class="label">المبلغ المدفوع</p></el-col>
              <el-col>
                <input
                  class="form-control"
                  @focus="$event.target.select()"
                  @keyup.enter="addPurchase"
                  id="paied"
                  v-model="purchases[selectedIndex].paied"
                />
              </el-col>
            </el-row>
          </div>
          <el-button
            class="mt-3 btn-green1 btn-save"
            type="success"
            @click="addPurchase"
            >حفظ</el-button
          >
          <el-button
            type="danger"
            @click="confirmSave = false"
            class="exit mr-2"
            >الغاء</el-button
          >
        </div>

        <br />
      </div>
      <!-- <div class="block">
    <span class="demonstration">Default</span>


      <el-date-picker
      :format="format"
    :value-format="valueFormat"
      v-model="value1"
      type="datetimerange"
      range-separator="إلي"
      start-placeholder="بداية الفترة"
      end-placeholder="نهاية الفترة">
    </el-date-picker>
    {{value1}}
  </div> -->
    </el-container>

    <el-dialog title="تسجيل منتج جديد" :visible.sync="addProductFormVisible">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="130px"
        class="demo-ruleForm"
      >
        <el-row :gutter="10">
          <el-col :xl="12" :lg="12" :md="24" :sm="24">
            <el-form-item label="اسم المنتج" prop="name">
              <search-fatura-products
                @resetFaturaSearch="resetFaturaSearch"
                @searchFaturaProducts="searchFaturaProducts"
                ref="searchFaturaComponent"
              />
              <!-- <el-input
                class="mt-2 input2"
                @focus="$event.target.select(), (index = 2)"
                v-model="form.name"
                @keyup.enter.native="focusNext"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <el-form-item label="عدد الوحدات" prop="units_per_package">
              <el-input
                class="mt-2 input2"
                id="units_per_package"
                type="number"
                @focus="$event.target.select(), (index = 2)"
                v-model="form.units_per_package"
                controls-position="right"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <div class="searchForm">
              <el-form-item label="الوحدة " prop="unit">
                <el-input
                  class="mt-2 input3"
                  id="unit"
                  @focus="$event.target.select(), (index = 3)"
                  v-model="form.unit"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <div class="searchForm">
              <el-form-item label="جملة الجملة" prop="wholesale_price">
                <el-input
                  class="mt-2 input4"
                  type="number"
                  id="wholesale_price"
                  @focus="$event.target.select(), (index = 4)"
                  v-model="form.wholesale_price"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xl="5" :lg="5" :md="12" :sm="12">
            <div class="searchForm">
              <el-form-item label=" سعر الجملة" prop="sale_price">
                <el-input
                  class="mt-2 input5"
                  type="number"
                  id="sale_price"
                  @focus="$event.target.select(), (index = 5)"
                  v-model="form.sale_price"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <div class="searchForm">
              <el-form-item label="  اقل سعر">
                <el-input
                  class="mt-2 input6"
                  id="min_price"
                  type="number"
                  @focus="$event.target.select(), (index = 7)"
                  v-model="form.min_price"
                  controls-position="right"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <div class="searchForm">
              <el-form-item label=" كود المنتج    ">
                <el-input
                  class="mt-2 input7"
                  type="number"
                  id="code"
                  @focus="$event.target.select(), (index = 8)"
                  v-model="form.barcode"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <div class="searchForm">
              <el-form-item label="  حد الطلب" prop="min_threshold">
                <el-input
                  class="mt-2 input8"
                  id="min_threshold"
                  type="number"
                  :min="10"
                  @focus="$event.target.select(), (index = 9)"
                  v-model="form.min_threshold"
                  controls-position="right"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="7" :lg="7" :md="12" :sm="12">
            <el-form-item label="  حدد التصنيف" prop="category">
              <el-select
                v-model="form.category"
                placeholder=" حدد التصنيف"
                @focus="index = 1"
                class="mt-2"
                :filterable="true"
                clearable
              >
                <el-option
                  v-for="item in productCategories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <br />
            <el-button
              class="mt-2"
              :disabled="isLoading"
              type="warning"
              @click="submitForm('form')"
            >
              تسجيل</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
import SearchSuppliers from "@/components/Suppliers/Search";
import SearchProducts from "@/components/Products/SearchWithLastBuyPrice";
import SearchFaturaProducts from "@/components/Products/SearchFatura";
import axiosApi from "@/plugins/axios.js";
// import SearchProductsWithBarcode from "@/components/Products/SearchBarcodeWithLastSalePrice";
// import { ipcRenderer } from "electron";

export default {
  components: {
    Aside,
    SearchSuppliers,
    SearchProducts,
    SearchFaturaProducts,
  },
  name: "Dashboard",
  data: () => ({
    newProductName: "",
    value1: "",
    invoice_details: null,
    activeSide: true,
    format: "yyyy-MM-dd HH:mm A",
    valueFormat: "yyyy-MM-dd HH:mm:ss",
    rules: {
      name: [
        {
          required: true,
          message: "مطلوب",
          trigger: "blur",
        },
      ],
      min_threshold: [
        {
          required: true,
          message: "مطلوب",
          trigger: "blur",
        },
      ],
      // category: [
      //   {
      //     required: true,
      //     message: "مطلوب",
      //     trigger: "change",
      //   },
      // ],
      units_per_package: [
        {
          required: true,
          message: "مطلوب",
          trigger: "blur",
        },
      ],
      unit: [
        {
          required: true,
          message: "مطلوب",
          trigger: "blur",
        },
      ],
      wholesale_price: [
        {
          required: true,
          message: "مطلوب",
          trigger: "blur",
        },
      ],
      sale_price: [
        {
          required: true,
          message: "مطلوب",
          trigger: "blur",
        },
      ],
    },
    index: 1,
    addProductFormVisible: false,
    productCategories: [],
    form: {
      faturaId: "",
      unit: "",
      name: "",
      category: 1,
      inventory_id: 1,
      units_per_package: "",
      min_threshold: 10,
      code: null,
      barcode: null,
      min_price: "",
      wholesale_price: "",
      sale_price: "",
    },
    confirmSave: false,
    setPaied: "without",
    productQuery: "",
    isLoading: false,
    supplier: null,
    product: null,
    productUnits: [],
    selectedUnit: null,
    sale_price: "",
    wholesale_price: "",
    buy_cost: "",
    min_price: "",
    qty: 1,
    active: "purchases",
    timeout: null,
    selectedProductlastBuyCost: "-",
    selectedProductStock: "",
    value: "",
    num: 1,
    ind: 0,
    activeDelete: false,
    selectedIndex: 0,
    showPrice: false,
    purchases: [
      {
        inventory_id: 1,
        // createdAt: this.$moment().locale("en").format().substring(0, 16),
        // createdBy: JSON.parse(Cookies.get("current_user")).user.name,
        // donne_at: this.$moment().locale("en").format("YYYY-MM-DD"),
        // inventory_id: JSON.parse(Cookies.get("current_user")).inventories[0]
        //   .id,
        paied: 0,
        VAT: 0,
        supplier: null,
        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        total_discount: 0,
        percentage_discount: 0,
        products: [],
      },
    ],
    useParcode: false,
    autoPush: false,
  }),
  created() {
    if (localStorage.getItem("purchases")) {
      let sale_data = localStorage.getItem("purchases");
      this.purchases = JSON.parse(sale_data);
      // this.checkOrderStock();
      this.supplier = this.purchases[this.selectedIndex].supplier;
      // if (this.purchases[this.selectedIndex].supplier != null) {
      //   this.getsupplierAccount();
      // } else {
      //   this.supplier = null;
      //   this.purchases[this.selectedIndex].supplier = null;
      // }
      this.calcTotal();
    }
    // this.checkOrderStock();
    this.getCategories();
  },
  watch: {
    setPaied: function () {
      this.purchases[this.selectedIndex].paied = 0;
      setTimeout(() => {
        document.getElementById("paied").focus();
      }, 100);
    },
    selectedIndex: function (newValue, oldValue) {
      // this.checkOrderStock();
      if (newValue != oldValue) {
        if (this.purchases[newValue].supplier != null) {
          this.supplier = this.purchases[newValue].supplier;
        } else {
          this.supplier = null;
        }

        this.$refs.searchSuppliersComponent.setValue(this.supplier);
      }
    },
  },
  methods: {
    addNewProductWithValue(e) {
      this.newProductName = e;
      this.addNewProduct();
    },
    clickAddButton() {
      this.$refs.searchProductsComponent.resetOptions();

      // setTimeout(() => {

      document.querySelector("#newProductBtn").click();
      document
        .querySelector("#newProductBtn")
        .dispatchEvent(new Event("click"));
      // }, 100);
    },
    showNewProductModel() {
      // newProductBtn
      if (this.purchases[this.selectedIndex].products.length > 0) {
        this.$refs.searchProductsComponent.resetOptions();

        document.querySelector("#newProductBtn").click();
      }
    },
    resetFaturaSearch() {
      this.resetForm("form");
    },
    checkOrderStock() {
      if (this.purchases[this.selectedIndex].products.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل الفاتورة",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axiosApi
          .post(`receipt/check-stock`, {
            products: this.purchases[this.selectedIndex].products,
          })
          .then((res) => {
            this.purchases[this.selectedIndex].products = res.data;
            this.setLocalStorage();
          })
          .catch((e) => {
            console.log(e);
            //   this.$snotify.error("عفوا لا يوجد منتج للباركود المحدد");
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تسجيل المنتج ",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          axiosApi
            .post("products/add", this.form)
            .then((res) => {
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات العميل بنجاح",
                type: "success",
                duration: 1500,
              });

              this.product = res.data[0];
              this.setProduct();

              this.addProductFormVisible = false;
            })
            .catch(() => {
              this.$notify({
                title: "حدث خطأ",
                message: "عفوا لم تتم العملية ",
                type: "error",
                duration: 1500,
              });
            })
            .finally(() => {
              this.isLoading = false;

              loading.close();
            });
        } else {
          console.log("error submit!!");
          console.log(" this.form", this.form);
          this.form;
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },
    showAddModel() {
      // this.$refs.searchProductsComponent.setValue(null);

      this.addProductFormVisible = true;
      setTimeout(() => {
        this.resetForm("form");
        this.form.name = this.productQuery;
        this.$refs.searchFaturaComponent.setValue(null, this.productQuery);
      }, 100);
    },
    focusNext() {
      if (this.index < 8) {
        if (this.form.name != "") {
          this.index += 1;
          let input = ".input" + this.index + " input";
          console.log(input);
          setTimeout(() => {
            document.querySelector(input).focus();
          }, 100);
        }
      } else {
        this.index = 1;
        //   document.querySelector('.input1 select').focus();
      }
    },
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.productCategories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    addNewProduct() {
      // delete this.form.wholesale_price;
      // delete this.form.unit;
      axiosApi
        .post("products", { name: this.newProductName })
        .then((res) => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات العميل بنجاح",
            type: "success",
            duration: 1500,
          });

          this.product = res.data[0];
          this.setProduct();

          // this.addProductFormVisible = false;
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    alert() {
      alert("price clicked");
    },
    newProductAdded(e) {
      this.product = e.product;
      this.addProductFormVisible = false;
    },
    discountPreChange() {
      this.purchases[this.selectedIndex].total_discount = parseFloat(
        (this.purchases[this.selectedIndex].percentage_discount *
          this.purchases[this.selectedIndex].total_buy_cost) /
          100
      ).toFixed(2);
      this.setLocalStorage();
    },
    openPaymentModal() {
      this.$prompt("حدد المبلغ", "تحصيل من العملاء", {
        confirmButtonText: "تحصيل",
        showClose: false,
        showCancelButton: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        inputValue: 0,
        customClass: "float-right",
        inputErrorMessage: "مبلغ غير صحيح",
      })
        .then(({ value }) => {
          if (value >= 0) {
            this.purchases[this.selectedIndex].paied = Number(value);
            this.addPurchase();
          } else {
            this.openPaymentModal();
            this.$notify({
              title: "حدث خطأ",
              message: "عفوا المبلغ غير صحيح ",
              type: "error",
              duration: 1500,
            });
          }
        })
        .catch(() => {
          this.purchases[this.selectedIndex].paied = 0;
        });
    },
    discountChange() {
      this.purchases[this.selectedIndex].percentage_discount = (
        parseFloat(
          this.purchases[this.selectedIndex].total_discount /
            this.purchases[this.selectedIndex].total_buy_cost
        ) * 100
      ).toFixed(2);
      this.setLocalStorage();
    },
    toggle(active) {
      this.activeSide = active;
    },
    removeSelectedOrder() {
      this.$confirm("هل تريد إلغاء الفاتورة ؟", "تحذير", {
        confirmButtonText: "موافق",
        cancelButtonText: "رفض",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.resetInvoiceData();

          this.$message({
            type: "success",
            message: "تم المسح بنجاح",
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: 'تم إلغاء'
          // });
        });
    },
    setSelectedInvoice(index) {
      this.selectedIndex = index;
      this.supplier = this.purchases[index].supplier;
      this.clearProduct();
    },
    addNewInvoice() {
      this.purchases.push({
        inventory_id: 1,
        supplier: null,
        paied: 0,
        VAT: 0,
        total_cost: 0,
        total_qty: 0,
        total_discount: 0,
        percentage_discount: 0,
        products: [],
      });
      this.selectedIndex = this.purchases.length - 1;
      this.$refs.searchSuppliersComponent.setValue(null);
    },
    setPriceFocus() {
      document.querySelector(".buy_cost input").focus();
    },
    setSalePriceFocus() {
      document.querySelector(".sale_price input").focus();
    },
    setWholeSalePriceFocus() {
      document.querySelector(".wholesale_price input").focus();
    },
    selectedSupplier(e) {
      this.supplier = e.supplier;
      this.purchases[this.selectedIndex].supplier = e.supplier;
      this.purchases[this.selectedIndex].project_id = e.project_id;
      this.setLocalStorage();
      if (e.customer != null) {
        document.querySelector(".productQuery input").focus();
        // if (!this.useParcode) {
        // } else {
        //   document.querySelector(".parcodeSearch input[type='text']").focus();
        // }
      }
    },

    productQueryChange(e) {
      this.productQuery = e.productQuery;
    },
    searchFaturaProducts(e) {
      console.log("searchFaturaProducts", e.product);
      if (e.product.id > 0 && e.exist == false) {
        this.form.name = e.product.name;
        this.form.faturaId = e.product.id;
        this.form.code = e.product.id;
        this.form.units_per_package = e.product.itemsPerUnit.substr(
          0,
          e.product.itemsPerUnit.indexOf(" ")
        );
        this.form.unit = e.product.unit;
        this.index = 1;
        this.focusNext();
      } else if (e.product.id > 0 && e.exist == true) {
        this.product = e.product;
        this.setProduct();
        this.addProductFormVisible = false;

        // this.focusNext();
      } else {
        this.form.name = e.product.name;
        this.form.faturaId = 0;
        this.index = 1;

        this.focusNext();
      }
      // this.getSupplierAccount();
    },
    selectedProduct(e) {
      this.product = e.product;
      this.productQuery = e.query;
      this.setProduct();

      // this.$refs.productSearch.focus();
    },
    setProduct() {
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);

        // this.buy_cost =
        //   this.product.inventories.length > 0 &&
        //   this.product.inventories[0].pivot.buy_cost;

        // this.sale_price =
        //   this.product.prices.length > 0 && this.product.prices[0].sale_price;
        // this.wholesale_price =
        //   this.product.prices.length > 0 &&
        //   this.product.prices[0].wholesale_price;

        // if (this.product.lastPurchase != null) {
        //   this.selectedProductlastBuyCost = this.product.lastPurchase.buy_cost;
        // } else {
        //   this.selectedProductlastBuyCost = "-";
        // }

        // this.selectedProductStock =
        //   (this.product.inventories[0].pivot.qty -
        //     this.product.inventories[0].pivot.hold_qty) /
        //   this.product.units_per_package;
        //   +
        // " " +
        // this.product.prices[0].unit;
        if (this.autoPush) {
          this.addNewItem();
        } else {
          setTimeout(() => {
            document.querySelector(".qty input").focus();
          }, 200);
        }
      } else {
        this.clearProduct();
      }
    },
    selectedProductWithBarcode(e) {
      this.product = e.product;
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);

        this.productUnits = e.product.prices;

        let selectedBarcodeUnit = e.product.prices.filter((item) => {
          return item.barcode == e.barcode;
        });

        this.selectedUnit = selectedBarcodeUnit[0];
        this.selectedUnitId = selectedBarcodeUnit[0].id;
        if (this.purchases[this.selectedIndex].supplier.price_type == 1) {
          this.sale_price = this.selectedUnit.wholesale_price;
        } else {
          this.sale_price = this.selectedUnit.sale_price;
        }
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductBuyCost = e.product.inventories[0].pivot.buy_cost;
        this.selectedProductStock =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        this.selectedProductStockLabel =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        //    +
        // " " +
        // this.productUnits[0].unit;
        if (e.product.unitLastInvoice != null) {
          this.selectedProductlastBuyCost =
            e.product.unitLastInvoice.sale_price;
        } else {
          this.selectedProductlastBuyCost = "-";
        }

        if (this.autoPush) {
          this.addNewItem();
        } else {
          setTimeout(() => {
            document.querySelector(".qty input").focus();
          }, 200);
        }
      } else {
        this.clearProduct();
      }
    },
    addNewItem() {
      if (this.product != null) {
        if (this.qty > 0) {
          let id = this.product.id;

          var product = this.purchases[this.selectedIndex].products.filter(
            function (elem) {
              if (elem.id == id) return elem;
            }
          );

          if (product.length > 0) {
            // this.search = "";
            // loader.hide();
            // console.log(product);
            this.purchases[this.selectedIndex].products.splice(
              this.purchases[this.selectedIndex].products.findIndex(
                (e) => e.id == id
              ),
              1
            );
            this.purchases[this.selectedIndex].products.push({
              id: product[0].id,
              name: product[0].name,
              buy_cost: Number(this.buy_cost),
              // units_per_package: product[0].units_per_package,
              // unit_type: product[0].unit_type,
              // unit: product[0].unit,
              sale_price: this.sale_price,
              wholesale_price: this.wholesale_price,
              // stock: product[0].stock,
              // lastPurchaseCost: product[0].lastPurchaseCost,
              qty: Number(product[0].qty) + Number(this.qty),
            });
            this.clearProduct();
            this.setLocalStorage();
            this.calcTotal();
          } else {
            // if (this.product.inventories.length > 0) {
            //   qty =
            //     this.product.inventories[0].pivot.qty -
            //     this.product.inventories[0].pivot.hold_qty;
            //   stock = Number(qty / this.product.units_per_package);
            // }
            // let lastPurchaseCost = 0;
            // if (this.product.lastPurchase) {
            //   lastPurchaseCost = this.product.lastPurchase.buy_cost;
            // }

            this.purchases[this.selectedIndex].products.push({
              id: this.product.id,
              name: this.product.name,
              buy_cost: Number(this.buy_cost),
              // unit:
              //   this.product.prices.length > 0 && this.product.prices[0].unit,
              sale_price: Number(this.sale_price),
              wholesale_price: Number(this.wholesale_price),
              // this.product.prices.length > 0 && this.product.prices[0].sale_price,
              // unit_type:
              //   this.product.prices.length > 0 && this.product.prices[0].type,
              // units_per_package: this.product.units_per_package,
              // stock: stock,
              // lastPurchaseCost: lastPurchaseCost,
              qty: Number(this.qty),
            });
            this.setLocalStorage();
            this.calcTotal();

            this.clearProduct();
          }
        }
      }
      this.scrollToEnd();
    },
    addPurchase() {
      if (!this.isLoading) {
        if (this.purchases[this.selectedIndex].products.length > 0) {
          this.isLoading = true;
          if (!this.purchases[this.selectedIndex].project_id) {
            console.log(this.purchases[this.selectedIndex]);
            this.$notify.error({
              title: "اختر مشروع للفاتورة",
              message: "يجب اختيار مشروع اولا",
              duration: 1500,
            });
            this.isLoading = false;
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل البيانات",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .post("purchases", this.purchases[this.selectedIndex])
            .then((response) => {
              console.log(response.data.purchase[0]);
              this.invoice_details = response.data.purchase[0];
              localStorage.setItem(
                "purchase_invoice",
                JSON.stringify(response.data.purchase)
              );

              this.resetInvoiceData();
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              this.confirmSave = false;
              // window.ipcRenderer = ipcRenderer;
              // let data = {
              //   data: this.invoice_details,
              //   type: "saleInvoice",
              //   title: "شراء",
              //   invoiceType: "sales",
              //   img:
              //     "https://pos.staging.fatura-app.com" +
              //     JSON.parse(localStorage.getItem("branch")).logo,
              // };
              // ipcRenderer.send("printing", data);
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify.error({
                  title: "لا يوجد رصيد كافي",
                  message: `لا يوجد رصيد كافي `,
                  duration: 1500,
                });
              } else {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من بيانات الفاتورة",
                  duration: 1500,
                });
              }
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      }
    },
    calcTotal() {
      let factory_cost = 0;
      var qty = 0;
      let buy = 0;
      for (
        var i = 0;
        i < this.purchases[this.selectedIndex].products.length;
        i++
      ) {
        if (this.purchases[this.selectedIndex].products[i].qty == "") {
          this.purchases[this.selectedIndex].products[i].qty = 1;
        }
        buy = Number(
          this.purchases[this.selectedIndex].products[i].qty *
            this.purchases[this.selectedIndex].products[i].buy_cost
        );
        factory_cost = factory_cost + buy;
        qty = qty + Number(this.purchases[this.selectedIndex].products[i].qty);
      }
      this.checkQty();
      this.purchases[this.selectedIndex].total_buy_cost = Number(factory_cost);
      this.purchases[this.selectedIndex].total_qty = Number(qty);
      this.discountChange();
      this.setLocalStorage();
    },
    checkQty() {
      for (
        var i = 0;
        i < this.purchases[this.selectedIndex].products.length;
        i++
      ) {
        if (Number(this.purchases[this.selectedIndex].products[i].qty) == 0) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }

        if (this.purchases[this.selectedIndex].products[i].qty == "") {
          this.purchases[this.selectedIndex].products[i].qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("purchases", JSON.stringify(this.purchases));
    },
    clearProduct() {
      // this.$refs.searchProductsWithBarcode.resetBarcode();
      this.$refs.searchProductsComponent.setValue(null);
      this.qty = 1;
      this.selectedProductStock = "";
      this.selectedProductlastBuyCost = "-";
      this.sale_price = "";
      this.wholesale_price = "";
      this.buy_cost = "";
      this.product = null;
      this.selectedUnit = null;
      this.productUnits = [];
      if (this.$refs.searchProductsComponent) {
        setTimeout(() => {
          document.querySelector(".productQuery input").focus();
          // if (!this.useParcode) {
          // } else {
          //   document.querySelector(".parcodeSearch input[type='text']").focus();
          // }
        }, 100);
      }
    },
    resetInvoiceData() {
      // this.products = null;
      this.supplier = null;
      this.$refs.searchSuppliersComponent.setValue(null);

      if (this.purchases.length > 1) {
        this.purchases.splice(this.selectedIndex, 1);
        this.selectedIndex = 0;
      } else {
        this.purchases[this.selectedIndex].products = [];
        // this.purchases[this.selectedIndex].donne_at = this.$moment()
        //   .locale("en")
        //   .format("YYYY-MM-DD");

        this.purchases[this.selectedIndex].supplier = null;

        this.purchases[this.selectedIndex].total_cost = 0;
        this.purchases[this.selectedIndex].paied = 0;
        this.purchases[this.selectedIndex].total_buy_cost = 0;
        this.purchases[this.selectedIndex].total_sale_cost = 0;
        this.purchases[this.selectedIndex].total_qty = 0;
        this.purchases[this.selectedIndex].total_discount = 0;
        this.purchases[this.selectedIndex].percentage_discount = 0;
        this.selectedIndex = 0;
      }
      setTimeout(() => {
        document.querySelector(".supplierQuery input").value = "";
        document.querySelector(".supplierQuery input").focus();
      }, 100);
      localStorage.setItem("purchases", JSON.stringify(this.purchases));
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    deleteItem(product, index) {
      // alert(index);

      this.purchases[this.selectedIndex].products.splice(index, 1);
      this.calcTotal();
    },
    useBarcode() {
      if (this.useParcode) {
        document.querySelector(".parcodeSearch input[type='text']").focus();
      } else {
        document.querySelector(".productQuery input").focus();
      }
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");

      // this.$el.querySelector("#goToBottom").click();
    },
    saveShortKey() {
      if (this.confirmSave) {
        this.addPurchase();
      }
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },

  mounted() {
    this.scrollToEnd();
  },
};
</script>

<style scoped lang="scss">
#scrollToMe {
  overflow-y: scroll;
}

.inline-card {
  display: inline-flex !important;
  gap: 8px;
  padding: 15px 32px !important;
  background: #fff;
  border-radius: 6px;
  span {
    &:first-of-type {
      font-weight: bold;
    }
  }
}
</style>
